import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import UserPurchasedSupplements from './user-purchased-supplements';
import UserPurchasedSupplementsDetail from './user-purchased-supplements-detail';
import UserPurchasedSupplementsUpdate from './user-purchased-supplements-update';
import UserPurchasedSupplementsDeleteDialog from './user-purchased-supplements-delete-dialog';

const UserPurchasedSupplementsRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<UserPurchasedSupplements />} />
    <Route path="new" element={<UserPurchasedSupplementsUpdate />} />
    <Route path=":id">
      <Route index element={<UserPurchasedSupplementsDetail />} />
      <Route path="edit" element={<UserPurchasedSupplementsUpdate />} />
      <Route path="delete" element={<UserPurchasedSupplementsDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default UserPurchasedSupplementsRoutes;
